import React from "react";
import { Link } from "react-router-dom";
import { Button } from "../ui/button";
import { Wrench, ArrowRight } from "lucide-react";

/**
 * Professional placeholder shown for modules that are still under active
 * configuration. NOT a generic "coming soon" — it explains what the module
 * will do, its current build phase, and gives the user something meaningful
 * to do while they wait.
 */
export function ModuleUnderConfiguration({
  title,
  purpose,
  capabilities = [],
  phase = "In Configuration",
  eta,
  fallback = [],
  testid,
}) {
  return (
    <div className="max-w-3xl" data-testid={testid || "module-under-configuration"}>
      <div className="flex items-start gap-4 mb-6">
        <div className="rounded-md bg-slate-100 p-3 flex-shrink-0">
          <Wrench size={22} className="text-[var(--cod-navy)]"/>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-[var(--cod-red)] font-semibold">{phase}</div>
          <h1 className="font-serif text-3xl text-slate-900 mt-1">{title}</h1>
          <div className="cod-rule-red mt-3"/>
        </div>
      </div>

      <p className="text-slate-700 leading-relaxed">{purpose}</p>

      {capabilities.length > 0 && (
        <div className="mt-6 rounded-lg border border-slate-200 bg-white p-5">
          <div className="text-xs uppercase tracking-widest text-slate-500 font-semibold mb-3">What this module will do</div>
          <ul className="space-y-2">
            {capabilities.map((c, i) => (
              <li key={i} className="flex items-start gap-3 text-sm text-slate-700">
                <span className="mt-1.5 h-1.5 w-1.5 rounded-full flex-shrink-0" style={{background:"var(--cod-red)"}}/>
                <span>{c}</span>
              </li>
            ))}
          </ul>
        </div>
      )}

      {eta && (
        <p className="mt-4 text-xs text-slate-500">Expected activation: <span className="text-slate-700 font-medium">{eta}</span></p>
      )}

      {fallback.length > 0 && (
        <div className="mt-6">
          <div className="text-xs uppercase tracking-widest text-slate-500 font-semibold mb-3">Available now</div>
          <div className="grid sm:grid-cols-2 gap-3">
            {fallback.map((f, i) => (
              <Link key={i} to={f.to} className="rounded-lg border border-slate-200 hover:border-[var(--cod-red)] bg-white p-4 flex items-center justify-between group">
                <div>
                  <div className="text-sm font-semibold text-slate-900">{f.label}</div>
                  {f.desc && <div className="text-xs text-slate-600 mt-1">{f.desc}</div>}
                </div>
                <ArrowRight size={16} className="text-slate-400 group-hover:text-[var(--cod-red)] transition"/>
              </Link>
            ))}
          </div>
        </div>
      )}

      <p className="mt-8 text-xs text-slate-500">
        Questions about your access or timing? Email <a href="mailto:info@joinCOD.org" className="cod-link">info@joinCOD.org</a>.
      </p>
    </div>
  );
}
